// extracted by mini-css-extract-plugin
module.exports = {"linkBox":"LinkBox_linkBox__muBxZ","linkBoxTitle":"LinkBox_linkBoxTitle__3v3aV","linkBoxDescription":"LinkBox_linkBoxDescription__1gL66"};